import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ width = "15", height = "15", fill = "#fff" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32.55 26.231"
    >
      <g id="folder-2" transform="translate(0 -39.611)">
        <g
          id="Сгруппировать_3757"
          data-name="Сгруппировать 3757"
          transform="translate(0 45.498)"
        >
          <g
            id="Сгруппировать_3756"
            data-name="Сгруппировать 3756"
            transform="translate(0 0)"
          >
            <path
              id="Контур_723"
              data-name="Контур 723"
              d="M29.336,112.653H3.214A3.228,3.228,0,0,0,0,115.873a.408.408,0,0,0,0,.054l1.867,13.887A3.228,3.228,0,0,0,5.1,133H27.466a3.228,3.228,0,0,0,3.229-3.182l1.854-13.887a.406.406,0,0,0,0-.054A3.228,3.228,0,0,0,29.336,112.653Z"
              transform="translate(0 -112.653)"
              fill={fill}
            />
          </g>
        </g>
        <g
          id="Сгруппировать_3759"
          data-name="Сгруппировать 3759"
          transform="translate(3.238 39.611)"
        >
          <g
            id="Сгруппировать_3758"
            data-name="Сгруппировать 3758"
            transform="translate(0 0)"
          >
            <path
              id="Контур_724"
              data-name="Контур 724"
              d="M63.858,42.248H53.393l-2.069-2.492a.4.4,0,0,0-.318-.145H42.558a2.406,2.406,0,0,0-2.387,2.418v2.325H66.223A2.4,2.4,0,0,0,63.858,42.248Z"
              transform="translate(-40.171 -39.611)"
              fill={fill}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default memo(Icon);
